import React, { Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import * as Actions from '../store/actions';

import { Button, SnackbarContent } from '@material-ui/core';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const styles = theme => ({
    root: {
        width: '90%',
    },
    button: {
        marginRight: theme.spacing.unit,
    },
    backButton: {
        marginRight: theme.spacing.unit,
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
});

// fake data generator
// a little function to help us with reordering the result

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    // padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    // background: isDragging ? "lightgreen" : "grey",
    background: isDragging ? "none" : "none",

    // styles we need to apply on draggables
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "lightgrey",
    // padding: grid,
    padding: '10px',
    width: '100%',
    border: '1px dashed black',
    minHeight: '200px'
});

class UnscheduledCourseLessonContainer extends Component {
    constructor(props) {
        super(props);

        this.onDragEnd = this.onDragEnd.bind(this);
    }

    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const item = this.props.selectedLessons.filter(l => l.lesson_id === result.draggableId)[0]
        if (this.props.match.params.view_type === 'edit') {
            this.props.moveUnscheduledLessonOutsideBuilder(result.source.index, result.destination.index, item)
        }
        else {
            this.props.moveUnscheduledLesson(result.source.index, result.destination.index, item)
        }
    }

    // Normally you would want to split things out into separate components.
    // But in this example everything is just done in one place for simplicity

    render() {
        return (
            <div style={{ padding: '20px' }}>
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable">

                        {(provided, snapshot) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                            >
                                <List>
                                    {this.props.selectedLessons.map((item, index) => (
                                        <Draggable key={item.lesson_id} draggableId={item.lesson_id} index={index}>
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}
                                                >
                                                    <ListItem>
                                                        <ListItemIcon><b>{index + 1}</b></ListItemIcon>
                                                        <SnackbarContent
                                                            style={{ width: '100%', backgroundColor: snapshot.isDragging ? '#707070' : '#181818'}}
                                                            message={item.LessonName}
                                                            action={
                                                                <Button style={{ color: 'white' }} size="small" onClick={() => this.props.handleDelete(item)}>
                                                                    DROP
                                                            </Button>
                                                            }
                                                        />
                                                        {/* {item.LessonName} */}
                                                    </ListItem>

                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </List>
                            </div>
                        )}

                    </Droppable>
                </DragDropContext>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        moveUnscheduledLessonOutsideBuilder: Actions.moveUnscheduledLessonOutsideBuilder,
        moveUnscheduledLesson: Actions.moveUnscheduledLesson
    }, dispatch);
}

function mapStateToProps({ courseApp }) {
    return {
    }
}

// Put the thing into the DOM!
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(UnscheduledCourseLessonContainer)));


// WEBPACK FOOTER //
// src/main/content/course/builderComponents/UnscheduledCourseLessonContainer.js